(function () {

  'use strict';

  function pxPrinterContextMenu(
    $timeout, $window, CopilotService
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        resource: '=resource',
        auxiliaries: '=auxiliaries',
        isThisResourceMine: '=isThisResourceMine',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        callback: '&callback',
      },
      // TEMPLATE USAGE -> px-printer-context-menu // 1 USAGE THIS IS APPROVED
      templateUrl: 'app/components/printerProperties/_printerContextMenu/printerContextMenu.template.html',
      link: function (scope, element, attrs) {


        (function() {
          initContexContent();
        })();

        scope.$watch(function() {
          return scope.contextPosition;
        }, function(oldVal, newVal){
          if (oldVal !== newVal) {
            initContexContent();
          }
        })

        function initContexContent() {
          checkValidPostion (scope.contextPosition.left, scope.contextPosition.top)
        };

        function checkValidPostion (left, top) {
          var offsetX = 60;
          var offsetY = 100;

          left = left - offsetX;
          var containerWidth = angular.element('.container').innerWidth();

          $timeout(function() {
            var menuHeight = angular.element('.context-content-container').innerHeight();
            var menuWidth = angular.element('.context-content-container').innerWidth();

            // if ($window.innerHeight <= 768) {
            //   var screenCenter = $window.innerHeight / 2;
            //   var menuCenter = menuHeight / 2;
            //   top = screenCenter - menuCenter;
            // } else if ((menuHeight + top) > $window.innerHeight) {
            //   top = ($window.innerHeight - menuHeight) / 2;
            // } else {
            //   top = top - offsetY;
            // }

            // var screenCenter = containerWidth / 2
            // var menuCenter = menuWidth / 2;
            // left = screenCenter - menuCenter;
            var screenVertCenter = $window.innerHeight / 2;
            var menuVerticalCenter = menuHeight / 2;
            top = screenVertCenter - menuVerticalCenter;

            var screenHorCenter = CopilotService.getAvailableWidth() / 2
            var menuHorizontalCenter = menuWidth / 2;

            left = screenHorCenter - menuHorizontalCenter;


            angular.element('.context-content-container').css({left: left , top: top});
            angular.element('.context-content-container').css({display: 'block'});
          }, 50)
        }

        scope.closePopup = function (bypass) {
          if (!bypass) {
            scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
          }
          // scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
        }

        scope.closePopupOnClickOutside = function (bypass) {
          // Don't close the dialog on outside click if the copilot window is open and configured
          // because the user might want to interact with the copilot window.
          const copilotOpenAndEnabled = CopilotService.state.chatOpen && CopilotService.state.configured;
          scope.closePopup(bypass || copilotOpenAndEnabled);
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxPrinterContextMenu.$inject = ['$timeout', '$window', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('pxPrinterContextMenu', pxPrinterContextMenu);

})();